const Toggle = () => {

    // Fetch all links with data-toggle attached
    let toggles = document.querySelectorAll('[data-toggle]');

    Array.from(toggles).forEach(toggle => {

        // Fetch the class name from the data attribute
        let className = toggle.getAttribute('data-toggle');
        // Find the corresponding element with this class name
        let targertElement = document.querySelector(`.${className}`);

        // If the element is defined/exists, proceed
        if (typeof targertElement != "undefined" && targertElement != null) {

            // When the link is clicked
            toggle.addEventListener('click', (e) => {

                // Toggle the --active BEM modifier on the referred element
                e.preventDefault();
                targertElement.classList.toggle(`${className}--active`);

            });
        }
    });
}

export default Toggle;